import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const FAQ_DATA = [{
  question: 'What is Giga?',
  answer: 'Giga is an AI employee that lives in Slack. It connects to the apps you already use and actually does the work. It drafts the reply, preps the meeting, files the follow-up, and pulls the data. Your day ends with things finished, not suggested.'
}, {
  question: 'Which apps and tools does Giga work with?',
  answer: "Giga ships with connectors for Slack, GitHub, Notion, HubSpot, Salesforce, Linear, Stripe, Zendesk, and more. Giga supports MCP, so any tool with an MCP server slots right in. If something you depend on isn't supported yet, our team scopes custom connectors for enterprise plans."
}, {
  question: 'Does Giga run on my computer?',
  answer: 'No. Giga runs securely in the cloud. It has its own isolated sandbox where it writes code, crunches files, and opens a browser when work lives behind a login. Nothing runs on your local machine.'
}, {
  question: 'How do I stay in control of what Giga does on my behalf?',
  answer: 'You have granular control over every permission. Giga only gets the access you explicitly grant, and you can require human approval for sensitive actions like sending emails or updating production databases.'
}, {
  question: 'Where does my data go? Is Giga safe to use with sensitive work?',
  answer: 'Yes. Giga stores access tokens encrypted at rest and isolated per workspace. Your data is never shared with other customers or used to train shared models. We respect your existing identity provider permissions.'
}, {
  question: 'How much does Giga cost?',
  answer: 'We offer a 7-day free trial. After that, plans start at $25/month for the Starter plan, with Pro and Custom tiers available for higher usage needs.'
}, {
  question: 'Is there a free trial?',
  answer: 'Yes, you can try Giga completely free for 7 days. You get 300 bonus credits per day to test out workflows and see how much time it saves your team.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [showAll, setShowAll] = useState(false);
  const visibleFaqs = showAll ? FAQ_DATA : FAQ_DATA.slice(0, 5);
  return <div className="w-full text-[#2B211A] font-body relative z-10" id="faq" data-id="element-1025">
      <div className="max-w-3xl mx-auto" data-id="element-1026">
        {/* Questions */}
        <div className="w-full flex flex-col" data-id="element-1027">
          <div className="flex flex-col" data-id="element-1028">
            <AnimatePresence initial={false} data-id="element-1029">
              {visibleFaqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return <motion.div key={faq.question} initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -20
              }} transition={{
                duration: 0.3,
                delay: index >= 5 ? (index - 5) * 0.05 : 0
              }} className="border-t border-dashed border-neutral-300 overflow-hidden" data-id="element-1030">
                    <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between gap-6 py-6 md:py-8 text-left focus:outline-none group" data-id="element-1031">
                      <span className="font-title font-bold text-xl md:text-2xl text-[#2B211A] leading-snug" data-id="element-1032">
                        {faq.question}
                      </span>
                      <motion.div animate={{
                    rotate: isOpen ? 180 : 0
                  }} transition={{
                    duration: 0.2
                  }} className="shrink-0 text-[#2B211A]" data-id="element-1033">
                        <ChevronDown className="w-5 h-5" strokeWidth={1.5} data-id="element-1034" />
                      </motion.div>
                    </button>
                    <AnimatePresence initial={false} data-id="element-1035">
                      {isOpen && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.3,
                    ease: 'easeInOut'
                  }} data-id="element-1036">
                          <div className="pb-8 pt-0 text-neutral-600 leading-relaxed text-base md:text-lg max-w-3xl" data-id="element-1037">
                            {faq.answer}
                          </div>
                        </motion.div>}
                    </AnimatePresence>
                  </motion.div>;
            })}
            </AnimatePresence>
            {/* Bottom border for the last item */}
            <div className="border-t border-dashed border-neutral-300" data-id="element-1038" />
          </div>

          {!showAll && FAQ_DATA.length > 5 && <div className="flex justify-start mt-8" data-id="element-1039">
              <button onClick={() => setShowAll(true)} className="text-sm font-medium text-[#2B211A] hover:text-[#EA580C] transition-colors flex items-center gap-1" data-id="element-1040">
                Read more FAQs <ChevronDown size={14} data-id="element-1041" />
              </button>
            </div>}
        </div>
      </div>
    </div>;
}